import { getLocationHost } from './locationUtils';

/**
 * Retrieves the value of the RELEASE_ENV environment variable.
 * @returns {string} The value of the RELEASE_ENV environment variable.
 */
export function getReleaseEnv() {
  return process.env.RELEASE_ENV;
}

/**
 * Checks if the environment is pre-production.
 * @returns {boolean} True if the environment is pre-production, false otherwise.
 */
export function PRE_PROD() {
  return getReleaseEnv() !== 'prod' || getLocationHost()?.includes('preview');
}

/**
 * Returns the Optimizely datafile ID based on the current release environment.
 * @returns {string} The Optimizely datafile ID.
 */
export function OPTIMIZELY_DATAFILE_ID() {
  return getReleaseEnv() === 'prod'
    ? 'SxQDAzMj39398zmwkDCG47'
    : 'Lt8wynKLp1jWEaFeVcsM48';
}
